<template lang="pug">
#group-wc
  .header.elem-header
    .elem-header.switch-button
      switch-toggle(
        :switch-value.sync='isShowGroupLayer',
        :switch-id='getIdGroup',
        @switchValueChanged='handleShowGroupLayer',
        ref='switch'
      )
    .content-header(@click='handleGroupClick')
      span.elem-header {{group.nome}}
      .elem-header.icon-group-show(v-if='isShowLayers')
      .elem-header.icon-group-hide(v-if='!isShowLayers')
  transition(name='slide')
    .body(v-show='isShowLayers' style='width: 100%; height: fit-content')
      div(v-for='area in group.areas', :key='area.id', style='width: 100%; height: 100%')
        layer(
          :ref='`layer${area.id}`',
          :visible='!!area.estilo.fill',
          :layer-id='area.id',
          :text='area.nome',
          :color='area.estilo.color',
          @layer:toggle='toggleLayers'
        )
</template>

<script>
import Layer from './Layer.vue';
import SwitchToggle from './SwitchToggle.vue';

export default {
  name: 'group',
  components: {
    Layer,
    SwitchToggle
  },
  props: {
    group: Object,
    showLayers: Boolean
  },
  computed: {
    getIdGroup() {
      return Math.floor((Math.random() * 10000) + 1);;
    }
  },
  data() {
    return {
      isShowLayers: true,
      isShowGroupLayer: true
    }
  },
  created() {
    this.group.areas.forEach(area => {
      if (!area.estilo.fill) {
        this.isShowGroupLayer = false;
      }
    });
  },
  methods: {
    toggleLayers(event) {
      this.$emit('layer:toggle', event);
    },
    handleGroupClick() {
      this.isShowLayers = !this.isShowLayers;
    },
    handleShowGroupLayer() {
      this.isShowGroupLayer = !this.isShowGroupLayer;
      const layersIds = [];
      for (const area of this.group.areas) {
        layersIds.push(area.id);
        const ref = this.$refs[`layer${area.id}`][0];
        ref.setVisibility(this.isShowGroupLayer);
      }
      this.$emit('layer:toggle', {
        layersIds,
        show: this.isShowGroupLayer
      });
    },
  }
}
</script>

<style scoped lang="scss">
#group-wc {
  position: relative;
  width: 99.5%;
  padding: 0.5px;
  font-weight: 600;

  .header {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    width: 100%;
    height: 35px;
    line-height: 25px;
    color: #333333;
    background-color: #f7f7f7;
    border-bottom: 2px solid #dedede;

      span {
        padding-left: 5px;
        color: #333333;
        width: 85.5%;
        height: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        float: left;
      }
      .icon-group-show {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMTIgOGwtNiA2IDEuNDEgMS40MUwxMiAxMC44M2w0LjU5IDQuNThMMTggMTR6Ii8+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        width: 5%;
        cursor: pointer;
      }
      .icon-group-hide {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMTYuNTkgOC41OUwxMiAxMy4xNyA3LjQxIDguNTkgNiAxMGw2IDYgNi02eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        width: 5%;
        cursor: pointer;
      }
      .elem-header {
        display: flex;
        align-items: center;
        justify-content: left;
      }
      .switch-button {
        width: 10%;
        justify-content: center;
      }
      .content-header {
        display: contents;
        cursor: pointer;
      }
  }

  .body {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }
  .background  {
    color: red;
  }
}
</style>
